import { render, staticRenderFns } from "./CircleWithInitials.vue?vue&type=template&id=7c09eb24&scoped=true"
import script from "./CircleWithInitials.vue?vue&type=script&lang=ts"
export * from "./CircleWithInitials.vue?vue&type=script&lang=ts"
import style0 from "./CircleWithInitials.vue?vue&type=style&index=0&id=7c09eb24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09eb24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c09eb24')) {
      api.createRecord('7c09eb24', component.options)
    } else {
      api.reload('7c09eb24', component.options)
    }
    module.hot.accept("./CircleWithInitials.vue?vue&type=template&id=7c09eb24&scoped=true", function () {
      api.rerender('7c09eb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CircleWithInitials.vue"
export default component.exports